import { motion } from "framer-motion";
import { RevealOnScroll } from "./RevealText";

const CHAPTERS = [
  {
    no: "01",
    title: "Fixed, honest fares",
    body: "No surge, no hidden charges. The price we quote on WhatsApp is the price you pay — toll and tax clarity upfront.",
  },
  {
    no: "02",
    title: "Local drivers who know Rajasthan",
    body: "Our chauffeurs have driven every road from Jodhpur to Jaisalmer for years. Safe hands, great stories, right shortcuts.",
  },
  {
    no: "03",
    title: "Always on, always ready",
    body: "Early flight or midnight arrival — book 24×7 on call or WhatsApp and a clean car reaches you on time, every time.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative bg-jodhpur-primary py-24 sm:py-32 grain-overlay overflow-hidden">
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <RevealOnScroll>
          <span className="text-xs uppercase tracking-[0.3em] text-jodhpur-accent font-semibold">Why Jodhpur Cabs</span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight max-w-2xl">
            A better way to travel the <span className="italic">Blue City.</span>
          </h2>
        </RevealOnScroll>

        <div className="mt-16 space-y-4">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`manifesto-chapter-${c.no}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline border-t border-white/15 pt-8 pb-4"
            >
              <div className="md:col-span-3">
                <span className="font-display text-6xl sm:text-7xl text-white/25 transition-colors group-hover:text-jodhpur-accent">
                  {c.no}
                </span>
              </div>
              <h3 className="md:col-span-4 font-display text-2xl sm:text-3xl text-white">
                {c.title}
              </h3>
              <p className="md:col-span-5 text-white/70 leading-relaxed">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
